export default {
  data() {
    return {
      screenWidth: window.innerWidth,
      isMobileDevice: /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent),
      isTouchEnabled: "ontouchstart" in window || navigator.maxTouchPoints > 0,
    };
  },
  computed: {
    isMobile960() {
      return this.screenWidth < 960;
    },
    isMobile768() {
      return this.screenWidth <= 768;
    },
    isMobile600() {
      return this.screenWidth < 600;
    },
    isResizedDesktop() {
      return this.isMobile960 && !this.isMobileDevice && !this.isTouchEnabled;
    },
    isResizedBuilderLayout() {
      // this is only if someone loads in 600px or less and decides to resize bigger than 600 and then lower again. prevents being stuck on layout column
      return this.screenWidth >= 600 && !this.isMobileDevice && !this.isTouchEnabled;
    }
  },
  methods: {
    updateWidth() {
      this.screenWidth = window.innerWidth;
    },
  },
  mounted() {
    this.updateWidth();
    window.addEventListener("resize", this.updateWidth);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateWidth);
  },
};
